import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AuthLayoutIndex from "../../layout/auth/AuthLayoutIndex";
import RootState from "../../redux/type";
import { resetPasswordAdmin } from "../../redux/userAuth";
import { ALL_ROUTES } from "../../routes/AllRoutes";
import "../../styles/auth/Login.css";
import { toast } from "../../components/razor-reuse/toast/RazorToast";
import RazorInputField from "../../components/razor-reuse/inputField/RazorInputField";

const ResetPassword = () => {
  const navigate = useNavigate();
  type detailsProps = {
    email: string;
    password: string;
    password_confirmation: string;
  };

  const dispatch = useDispatch();
  const { loading } = useSelector((state: RootState) => state.auth);

  const [details, setDetails] = useState<detailsProps>({
    email: "",
    password: "",
    password_confirmation: "",
  });

  const handleChange = (e: any) => {
    e?.preventDefault?.();
    const { name, value } = e?.target;

    const obj = { ...details, [name]: value };
    setDetails(obj);
  };

  const ref = localStorage?.getItem("password_reference");
  const email = localStorage?.getItem("user_email");

  const resetPasswordFunc = async () => {
    // if (!validatePasswordLowercase(details.password)) {
    //   toast.error("Password should have at least 1 lowercase letter");
    //   return;
    // }
    // if (!validatePasswordUpperCase(details.password)) {
    //   toast.error("Password should have at least 1 capital letter");
    //   return;
    // }
    // if (!validatePasswordSpecialCharacter(details.password)) {
    //   toast.error("Password should have at least 1 special character");
    //   return;
    // }
    // if (!validatePasswordNumber(details.password)) {
    //   toast.error("Password should have at least  1 numeric character.");
    //   return;
    // }
    if (details?.password !== details?.password_confirmation) {
      toast.error("Passwords does not match!!!");
      return;
    }
    const obj = {
      password: details?.password,
      password_confirmation: details?.password_confirmation,
      reference: ref,
      email: email,
    };
    const data = await dispatch(resetPasswordAdmin(obj) as any);
    if (data?.payload?.data?.status) {
      toast.success(data?.payload?.data?.message);
      localStorage?.clear();
      navigate(ALL_ROUTES?.LOGIN);
    }
    if (data?.payload?.response?.data?.status === "failed") {
      const messg = data?.payload?.response?.data?.errors?.email;
      toast.error(messg);
    }
  };

  useEffect(() => {
    if (!email || !ref) {
      navigate(ALL_ROUTES?.FORGOT_PASSWORD);
    }
  }, []);

  return (
    <>
      <AuthLayoutIndex
        text={`Password should contain: Uppercase and \n lowercase letters, numbers, symbols`}
        title="Setup New Password"
      >
        <div className="auth-login-wrapper-box">
          <form
            action=""
            onSubmit={(e) => {
              e.preventDefault();
              resetPasswordFunc();
            }}
            className="form"
            autoComplete="off"
          >
            <RazorInputField
              color="black-light"
              type="password"
              label="New Password"
              value={details?.password}
              name="password"
              onChange={handleChange}
              showPasswordStrength={true as any}
              placeholder="Enter password"
              style={{ position: "relative", zIndex: 12 }}
            />
            <RazorInputField
              color="black-light"
              type="password"
              label="Confirm New Password"
              value={details?.password_confirmation}
              name="password_confirmation"
              onChange={handleChange}
              placeholder="Enter confirm password"
            />

            <RazorInputField
              className="submit-btn"
              color="black-light"
              type="submit"
              value={`Save Password`}
              disabled={!details?.password || !details?.password_confirmation}
              onSubmit={resetPasswordFunc}
              loading={loading}
            />
          </form>
          {/* dont have account start */}
          <div style={{ marginTop: "3rem" }} className="down-text-box">
            <p className="text">
              Remember Password?{" "}
              <span
                onClick={() => {
                  navigate(ALL_ROUTES?.LOGIN);
                }}
              >
                Login
              </span>
            </p>
          </div>
          {/* dont have account end */}
        </div>
      </AuthLayoutIndex>
    </>
  );
};

export default ResetPassword;
